import "./WelcomeKit.css"
import MultiStepForm from '../../../components/WelcomeKit/MultiStepForm';

const WelcomeKit = () => {
    return (
        <div style={{ margin: '0 auto', height: '92vh' }}>
            <MultiStepForm />
        </div>
    )
}

export default WelcomeKit